// src/pages/FeaturesPage.js
import { Helmet } from "react-helmet";
import React from "react";
import { Link, useNavigate } from "react-router-dom";

const FeaturesPage = () => {
  const navigate = useNavigate();

  const navButtonStyle = {
    background: "transparent",
    color: "rgba(255,255,255,0.85)",
    border: "none",
    fontSize: "1rem",
    cursor: "pointer",
    fontWeight: "500",
    textDecoration: "none",
    transition: "all 0.2s ease",
  };

  const handleHover = (e, entering) => {
    e.target.style.color = entering ? "#ffffff" : "rgba(255,255,255,0.85)";
    e.target.style.transform = entering ? "translateY(-1px)" : "translateY(0)";
  };

  return (
    <>
  <Helmet>
    <title>PBIS Software Features for Schools | PBIS Portal</title>
    <meta
      name="description"
      content="Explore PBIS Portal features including ticket tracking, student rewards, and PBIS store management for schools."
    />
    <link rel="canonical" href="https://pbisportal.com/features" />
  </Helmet>
    <div style={{ fontFamily: "'Segoe UI', sans-serif", backgroundColor: "#f8fafc" }}>
      
      {/* HEADER */}
      <header
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          padding: "1rem 2rem",
          backgroundColor: "#1e3a8a",
          color: "white",
          position: "sticky",
          top: 0,
          zIndex: 1000,
          boxShadow: "0 2px 8px rgba(0, 0, 0, 0.12)",
        }}
      >
        <Link
          to="/"
          style={{
            fontSize: "1.8rem",
            fontWeight: "700",
            cursor: "pointer",
            color: "white",
            textDecoration: "none",
          }}
        >
          🎯 PBIS Portal
        </Link>

        <div style={{ display: "flex", alignItems: "center", gap: "1.5rem" }}>
          <Link
            to="/about"
            style={navButtonStyle}
            onMouseEnter={(e) => handleHover(e, true)}
            onMouseLeave={(e) => handleHover(e, false)}
          >
            About
          </Link>

          <Link
            to="/features"
            style={navButtonStyle}
            onMouseEnter={(e) => handleHover(e, true)}
            onMouseLeave={(e) => handleHover(e, false)}
          >
            Features
          </Link>

          <Link
            to="/what-is-pbis"
            style={navButtonStyle}
            onMouseEnter={(e) => handleHover(e, true)}
            onMouseLeave={(e) => handleHover(e, false)}
          >
            What is PBIS
          </Link>
          <Link
  to="/contact"
  style={navButtonStyle}
  onMouseEnter={(e) => handleHover(e, true)}
  onMouseLeave={(e) => handleHover(e, false)}
>
  Contact
</Link>

          {/* Divider */}
          <div
            style={{
              width: "1px",
              height: "20px",
              background: "rgba(255,255,255,0.3)",
            }}
          />

          <Link
            to="/login"
            style={{
              backgroundColor: "#2563eb",
              color: "#fff",
              border: "none",
              padding: "0.65rem 1.2rem",
              fontSize: "1rem",
              borderRadius: "8px",
              cursor: "pointer",
              fontWeight: "600",
              marginLeft: "0.5rem",
            }}
          >
            Log In
          </Link>
        </div>
      </header>

      {/* HERO */}
      <section
        style={{
          textAlign: "center",
          padding: "4rem 2rem",
          background: "linear-gradient(135deg, #e0f2fe 0%, #ecfeff 100%)",
        }}
      >
        <h1 style={{ fontSize: "2.8rem", fontWeight: "800", marginBottom: "1rem" }}>
          PBIS Features Built for Real Schools
        </h1>

        <p
          style={{
            fontSize: "1.2rem",
            maxWidth: "700px",
            margin: "0 auto",
            color: "#475569",
            lineHeight: "1.7",
          }}
        >
          PBIS Portal is a complete PBIS rewards system designed to help schools
          recognize positive behavior, track student growth, and simplify incentives.
        </p>
      </section>

      {/* FEATURES GRID */}
      <section
        style={{
          maxWidth: "1000px",
          margin: "3rem auto",
          padding: "0 1.5rem",
          display: "grid",
          gap: "1.75rem",
        }}
      >
        <Feature
          title="🎫 PBIS Ticket System"
          desc="Easily give digital PBIS tickets to students for positive behavior. Track who earned tickets, when, and why — all in real time."
        />

        <Feature
          title="📊 Real-Time Tracking"
          desc="Monitor student progress, advisory totals, and school-wide trends with live data dashboards built for PBIS teams."
        />

        <Feature
          title="🏆 Student Rewards Store"
          desc="Create a custom PBIS reward store where students can redeem tickets for incentives, privileges, or items."
        />

        <Feature
          title="⚙️ Simple Admin Tools"
          desc="Manage students, staff, advisories, and PBIS values in one place with an easy-to-use admin dashboard."
        />

        <Feature
          title="🏫 School-Wide PBIS Support"
          desc="Designed for MTSS and PBIS frameworks, helping schools build a positive culture focused on recognizing student success."
        />
      </section>

      {/* WHY SECTION */}
      <section
        style={{
          backgroundColor: "#ffffff",
          padding: "3rem 2rem",
          textAlign: "center",
        }}
      >
        <h2 style={{ fontSize: "2rem", marginBottom: "1rem" }}>
          Why Schools Choose PBIS Portal
        </h2>

        <p
          style={{
            maxWidth: "750px",
            margin: "0 auto",
            color: "#475569",
            lineHeight: "1.7",
          }}
        >
          PBIS Portal focuses on what matters most — recognizing and reinforcing positive
          student behavior. Instead of tracking discipline, our platform is built to
          celebrate growth, encourage engagement, and make PBIS implementation simple.
        </p>
      </section>

      {/* CTA */}
      <section
        style={{
          textAlign: "center",
          padding: "3rem 2rem",
        }}
      >
        <h2 style={{ marginBottom: "1rem" }}>
          Ready to bring PBIS to your school?
        </h2>

        <button
          onClick={() => navigate("/signup")}
          style={{
            backgroundColor: "#6366f1",
            color: "white",
            fontSize: "1rem",
            padding: "0.75rem 1.75rem",
            border: "none",
            borderRadius: "8px",
            cursor: "pointer",
            fontWeight: "600",
            boxShadow: "0 6px 18px rgba(99, 102, 241, 0.3)",
          }}
        >
          Get Started
        </button>
      </section>
      </div>
</>
);
};

const Feature = ({ title, desc }) => (
  <div
    style={{
      backgroundColor: "#ffffff",
      padding: "1.75rem",
      borderRadius: "14px",
      boxShadow: "0 4px 14px rgba(0,0,0,0.06)",
    }}
  >
    <h3 style={{ marginBottom: "0.5rem" }}>{title}</h3>
    <p style={{ color: "#475569", lineHeight: "1.6" }}>{desc}</p>
  </div>
);

export default FeaturesPage;
